import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import MultipleSelect from 'components/commons/multiple-select'

export const BestDeals = ({
    isShow,
    bestDealsDetail,
    optionsProduct,
    errorForm,
    onChangeForm,
    onSearchProduct,
    isLoading,
    isUpdating,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-6'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>Best Deals</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{!isShow ? 'Hide' : 'Show'}</p>
                            <Switch name={'is_show'} checked={!!isShow} onChange={onChangeForm} />
                        </div>
                    </div>
                    <TabToggle
                        title={'General'}
                        content={
                            <div className={'flex flex-col space-y-5'}>
                                <div className={'flex-1 flex-col space-y-3 w-1/2'}>
                                    <div className={'font-semibold text-blue-90 required'}>Title</div>
                                    <Input
                                        className={'flex-1'}
                                        name={'title'}
                                        placeholder={'Masukkan title'}
                                        value={bestDealsDetail?.title}
                                        onChange={onChangeForm}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.best_deal?.title} />
                                </div>
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Pilih Product</div>
                                    <MultipleSelect
                                        name={'product_ids'}
                                        placeholder={'Search Product...'}
                                        onSearch={onSearchProduct}
                                        value={bestDealsDetail?.product_ids}
                                        options={optionsProduct}
                                        onChange={onChangeForm}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.best_deal?.product_ids} />
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
